import React from 'react';
import TypedLink from '../TypedLink/TypedLink.js';
import SlideInContent from '../AnimatedElements/SlideInContent.js';
import Accordion from '../AnimatedElements/Accordion.js';
import { ReactSVG } from "react-svg";
import { Link  } from "react-router-dom";
import i18n from '../../i18n/i18n.js';

import './ProfileMenu.css';

class ProfileMenu extends React.Component {

  emptyFormData = {
    coupon_code: '',
  };

  emptyFormErrors = {
    coupon_code: '',
  };

  animationObjectRef = new React.createRef();

  // Csak bejelentkezve elérhető menüpontok. 
  // Tetszőleges tulajdonság megadható a szűréshez.
  signInMenus = [
    { component_name: 'MyMessages' },
    { component_name: 'Profile' },
    { component_name: 'MyOrders' },
    { component_name: 'Wishlist' },
    { component_name: 'RoyaltyCard' },
  ];

  constructor(props) {
    super(props);

    this.state = {
      show: false,
      url_withdrawal: '',
      is_signed: window.AppRef.current.get_is_signed()
    };
  }

  componentDidMount() {
    const that = this;

    let url_withdrawal = window?.AppRef?.current?.state?.settings?.settings?.WS_URL_ORDERS_WITHDRAWAL;

    this.setState({ url_withdrawal: url_withdrawal });

    if(!url_withdrawal?.length) 
    {
      window?.AppRef?.current?.get_settings()
          .then((resp_settings) => {
              let url_withdrawal = resp_settings?.settings?.settings?.WS_URL_ORDERS_WITHDRAWAL;

              that.setState({ show: true, url_withdrawal: url_withdrawal });
              that.animationObjectRef.current.setVisible(true);
          });
    }
  }

  is_visible() {
    return this.state.show;
  }

  show() {
    this.setState({ show: true });
    this.animationObjectRef.current.setVisible(true);
  }

  hide() {
    this.setState({ show: false });
    this.animationObjectRef.current.setVisible(false);
    window.AppFooterMenuRef.current.set_item_inactive_by_name('menu_profile');
  }

  toggle() {
    if (this.state.show) {
      this.hide();
    }
    else {
      this.show();
    }
  }

  show_accordion_header(item) {
    return <>
      <TypedLink link={{type: item.url_type, url: item.url, title: item.title}}></TypedLink>
    </>;
  }

  is_showable_menu(menu) {
    let result = true;

    if (!window.AppRef.current.get_is_signed())
    {
      this.signInMenus.forEach(conf => {
        const attr = Object.keys(conf)[0];
        const val = Object.values(conf)[0];

        if (menu[attr] === val)
        {
          result = false;
        }
      });
    }

    return result;
  }

  show_accordions(pages){

    return <>
      { Object.keys(pages).map((id,key)=>{
        const val = pages[id];

        if(val['sublevels'] && Object.keys(val['sublevels']).length>0){
          return <Accordion key={val.id} id={val.id} header={this.show_accordion_header(val)} content={this.show_accordions(val['sublevels'])}></Accordion>
        }else{
          return this.is_showable_menu(val) ? <li className='no_sub' key={val.id}>
            {!!val.url.length
              ? <TypedLink onClick={val.url_type !== 'component' ? () => { this.hide(); } : () => {}} link={{type: val.url_type, url: val.url, title: val.title}}></TypedLink>
              : <p onClick={val.url_type == 'component' ? () => {
                if (typeof window.modals[val.component_name + 'Ref'] !== 'undefined')
                {
                  window.modals[val.component_name + 'Ref'].current.show();
                }
              } : () => {}}>{val.title}</p>
            }
            <ReactSVG className='menu_icon' src="assets/images/scissors.svg" />
          </li> : '';
        }  

      })}
    </>
    
  }
    
  render() {
    const menus = window.AppRef.current.state.menus[7];

    return <SlideInContent key={this.state.is_signed + ' ' + this.state.url_withdrawal} ref={this.animationObjectRef}
      className="container floating_container page_profile_menu">
      <div className="header_back"><ReactSVG className='products_back_icon' src="assets/images/back.svg" onClick={() => this.hide()} /></div>
        <div className='header_menu_items_cont'>
          <ul className='accordions_cont'>

          {!this.state.is_signed ? 
          <li className='no_sub' key="sign_in">
            <Link onClick={() => window.modals.ProfileMenuRef.current.hide()} data-type="in_app" to="/welcome">{i18n.t('signInTitle')}</Link>
            <ReactSVG className='menu_icon' src="assets/images/scissors.svg" />
          </li> : ''}

          {!this.state.is_signed ? 
          <li className='no_sub' key="account_create">
            <Link onClick={() => window.modals.ProfileMenuRef.current.hide()} data-type="in_app" to="/welcome">{i18n.t('accountCreateTitle')}</Link>
            <ReactSVG className='menu_icon' src="assets/images/scissors.svg" />
          </li> : ''}

          {!this.state.is_signed ? 
          <li className='no_sub' key="account_create">
            <Link onClick={() => window.modals.ProfileMenuRef.current.hide()} data-type="in_app" to="/welcome">{i18n.t('accountCreateTitle')}</Link>
            <ReactSVG className='menu_icon' src="assets/images/scissors.svg" />
          </li> : ''}

          {this.show_accordions(menus)}

          {this.state?.url_withdrawal?.length ? (
          <li className='no_sub' key="orders_withdrawal">
            <a target="_blank" href={this.state.url_withdrawal}>{i18n.t('ordersWithdrawal')}</a>
            <ReactSVG className='menu_icon' src="assets/images/scissors.svg" />
          </li>
          ) : ''}

          </ul>
        </div>
    </SlideInContent>
  }
}

export default ProfileMenu;
